// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + {"72":"Cart","187":"NotFound","344":"FullPizza"}[chunkId] + "." + {"72":"3a70f84b","187":"7edd2bf1","344":"7122d505"}[chunkId] + ".chunk.js";
};